/* eslint-disable react/jsx-curly-brace-presence */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle';
import { Button } from 'react-bootstrap';
import {
  apiUsers,
  modals
} from 'ducks';
import Placeholder from 'components/Placeholder';
import LinkButton from 'components/LinkButton/LinkButton';
import { formatDateTime } from 'utils';
import { duckify } from 'utils/duckify';
import FA from 'utils/FA';
import ApiCredentialsModal, { DisplayApiSecretMessage } from '../ApiCredentials/ApiCredentialsModal';
import EditableAttribute from "../shared/EditableAttribute";

import './styles/ManageExternalApiCredentials.scss';

const ManageExternalApiCredentials = (props) => {
  const {
    users,
    createUser,
    destroyUser,
    updateUser
  } = props;

  const [detailUser, setDetailUser] = useState(null);

  return (
    <React.Fragment>
      <h2>External API Credentials</h2>
      {users.error && <div className={'alert alert-danger'}>{users.errorMessage}</div>}
      <table className={'api-users-table table'}>
        <thead>
          <tr>
            <th>User ID</th>
            <th className={'api-users-table-description'}>Description</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <Placeholder.table
          ready={users.ready}
          content={() => (
            <tbody>
              {users.map(user => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>
                    <EditableAttribute
                      attribute={'description'}
                      entity={user}
                      onChange={(_, value) => updateUser({id: user.id,  description: value})}
                    />
                  </td>
                  <td>{formatDateTime(user.created_at)}</td>
                  <td>
                    <Button
                      variant={'link'}
                      onClick={() => setDetailUser(user)}
                    >
                      View Details
                    </Button>

                    <Button
                      className={'text-danger'}
                      variant={'link'}
                      onClick={() => destroyUser(user)}
                    >
                      Destroy
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        />
      </table>
      <div>
        <LinkButton
          className={'text-success'}
          onClick={() => createUser()}
          content={(
            <span>
              <FA icon={faPlusCircle} postNbsp />
              Create New API User
            </span>
          )}
        />
      </div>
      {detailUser && <ApiCredentialsModal apiUser={detailUser} onClose={() => setDetailUser(null)} />}
    </React.Fragment>
  );
};

ManageExternalApiCredentials.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    created_at: PropTypes.string
  })).isRequired,
  createUser: PropTypes.func.isRequired,
  destroyUser: PropTypes.func.isRequired
};

const mapDucksToProps = () => ({
  users: apiUsers
});

const mapDispatchToProps = (dispatch) => ({
  createUser: () => dispatch(apiUsers.actions.create())
    .then(apiUsers.actions.denormalizeObjects)
    .then(user => {
      const { api_credentials } = user;
      const [credential] = api_credentials;
      dispatch(modals.actions.show('MessageModal', {
        title: 'API Secret',
        message: <DisplayApiSecretMessage {...credential} />
      }));
    }),
  destroyUser: user => (
    dispatch(modals.actions.show('VerificationModal', {
      title: 'Confirm Destroy API User',
      message: (
        <div>
          <h2>Are you sure you want to destroy this API User?</h2>
          <p>
            Any applications currently using credentials for this user
            will immediately be de-authorized. This operation is not
            recoverable.
          </p>
        </div>
      ),
      onConfirm: () => dispatch(apiUsers.actions.remove(user)).then(dispatch(apiUsers.actions.markDirty()))
    }))
  ),
  updateUser: user => dispatch(apiUsers.actions.update(user))
});

export default duckify(mapDucksToProps, () => ({}), mapDispatchToProps)(ManageExternalApiCredentials);
